import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const CircleDisabled24: FC<IconV2Props> = ({ icon, chroma, className }) => {
  const isDark = chroma === 'dark';

  return (
    <svg
      className={
        isDark
          ? cn(s.svgDark24, `svg-icon--${icon}`, className)
          : cn(s.svgLight24, `svg-icon--${icon}`, className)
      }
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-icon={isDark ? `${icon}-24-solid` : `${icon}-24`}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-18.000000, -18.000000)"
          className={isDark ? s.darkStroke : s.lightStroke}
        >
          <g transform="translate(18.000000, 18.000000)">
            <circle
              fillOpacity={isDark ? 1 : 0.2}
              fill="#000000"
              cx="12"
              cy="12"
              r="11.5"
            />
            <line
              className={isDark ? s.darkStroke : s.lightStroke}
              x1="6.5"
              y1="12"
              x2="17.5"
              y2="12"
              strokeWidth="2"
              strokeLinecap="square"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CircleDisabled24;
